import React from 'react';
import { evalObject, evalTableRow } from './types';
import commonService from 'utils/commonService';

type IProps = {
  selectedCalcPlan: {
    PLAN_ID: string
  };
  setSelectedCalcPlan: (value: string) => void;
  evalResult: any;
  evalTableData: Array<evalTableRow>;
  calcRef: any;
}

const planName = ['基本呵護3.0', '完整保護3.0', '全面守護3.0'];

const CalcPlansTable: React.FC<IProps> = (props) => {
  return (
    <>
      <table
        ref={props.calcRef}
        className="plan-table"
        style={{
          width: '100%',
          maxWidth: '1024px',
          marginBottom: '10px',
          textAlign: 'center'
        }}
      >
        <tr>
          <th rowSpan={2} style={{ verticalAlign: 'middle' }}>保險項目</th>
          <th rowSpan={2} colSpan={2} style={{ verticalAlign: 'middle' }}>承保範圍</th>
          {props.evalResult.map((plan:evalObject, i:number) => (
            <th key={plan.PLAN_ID} className="plan-select">
              <div className="plan-select-container">
                <span>{planName[i]}</span>
                <div className="pet-plan-select-button">
                  <label>
                    <span>我要保這個</span>
                    <input
                      id={`plan-${i}`}
                      data-index-number={i}
                      type="radio"
                      value={plan.PLAN_ID}
                      checked={plan.PLAN_ID === props.selectedCalcPlan.PLAN_ID}
                      data-plan-name={planName[i]}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (e.target.dataset.indexNumber) {
                          props.setSelectedCalcPlan({
                            ...props.evalResult[+e.target.dataset.indexNumber],
                            planName: e.target.dataset.planName
                          });
                        }
                      }}
                    />
                  </label>
                </div>
              </div>
            </th>
          ))}
        </tr>
        <tr>
          <th colSpan={3}>保險金額（NT$）</th>
        </tr>
        {props.evalTableData.map((row, i:number) => (
          <tr key={commonService.uuidv4()}>
            {i === 0 ? <td rowSpan={9} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>寵物醫療費用</td> : null}
            {i === 0 ? <td rowSpan={3} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>門診費用</td> : null}
            {i === 3 ? <td rowSpan={3} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>住院費用</td> : null}
            {i === 6 ? <td rowSpan={3} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>手術費用</td> : null}
            {i > 8 ? <td colSpan={3} className="element__table-grid-y-title-pet">{row.title}</td> : <td className="element__table-grid-y-title-pet">{row.title}</td>}
            {row.value.map(value => (
              <td key={commonService.uuidv4()}>{typeof value === 'number' ? commonService.amountFormat(value) : value}</td>
            ))}
          </tr>
        ))}
      </table>
      {/* <div style={{ color: 'red', textAlign: 'left', marginBottom: '10px' }}>
        <span style={{ display: 'block' }}>本商品並非保證續保，隔年度將依據實際理賠狀況決定續保保險費以及是否得以續保，有關續保保險費調整之說明如下</span>
      </div>
      <table className="plan-table fee-adjustment-table">
        <tr>
          <th colSpan={2}>無賠款減費</th>
          <th colSpan={2}>賠款加費</th>
        </tr>
        <tr>
          <th>無賠款年度</th>
          <th>減費標準</th>
          <th>前一年度賠款次數</th>
          <th>加費標準</th>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">前一年度</td>
          <td>減費20%</td>
          <td>2次以下</td>
          <td>無加費</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">連續兩年</td>
          <td>減費30%</td>
          <td>3次</td>
          <td>加費30%</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">連續3年或以上</td>
          <td>減費40%</td>
          <td>4次</td>
          <td>加費50%</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet element__table-grid-y-title-pet-placeholder" colSpan={2} />
          <td>超過4次</td>
          <td>每增加1次，加費10%</td>
        </tr>
      </table>
      <div style={{ color: 'red', textAlign: 'left' }}>
        <span style={{ display: 'block' }}>註1：加減費僅限「寵物醫療費用保險」此承保項目，且賠款次數以保險事故次數為計算基礎。</span>
        <span style={{ display: 'block' }}>註2：前1年度無賠款紀錄者，即以減費標準計算續保保險費，有賠款紀錄則以加費標準計算。</span>
        <span style={{ display: 'block' }}>註3：保險人於保單到期前結算賠款次數，倘於該期間後申請理賠而未結算之賠款次數，則納入下年度計算。</span>
      </div> */}
    </>
  );
};

export default CalcPlansTable;
